import React from "react";
import "./RecentWorkSum.css";
import { Link } from "react-router-dom";

function RecentWorkSum() {
  return (
    <div className="rcnt_wrk_wrpr" id="work">
      <p className="bf hdr">Our Latest Work</p>
      <div className="rcnt_wrk_innr_wrpr">
        <div className="ib sec maroon" />
        <div className="ib sec blue recent-1" />
        <div className="ib sec purple recent-2" />
        <div className="ib sec green recent-3" />

        <div className="bslf mor_btn_wrpr">
          <Link to="/portfolio">
            <button className="bslf mor_btn">See more</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default RecentWorkSum;



// WEBPACK FOOTER //
// ./src/components/RecentWorkSum.js